import React from "react";
import ContentSwitcher from "./components/ContentSwitcher";
import Hrline from "../Hrline";

const Gallery = () => {
  return (
    <div>
      <Hrline />
      <ContentSwitcher />
    </div>
  );
};

export default Gallery;
